import { render, staticRenderFns } from "./customerDppmPage.vue?vue&type=template&id=e2c2618c&scoped=true&"
import script from "./customerDppmPage.vue?vue&type=script&lang=js&"
export * from "./customerDppmPage.vue?vue&type=script&lang=js&"
import style0 from "./customerDppmPage.vue?vue&type=style&index=0&id=e2c2618c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c2618c",
  null
  
)

export default component.exports